import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';

import { FilterRequest, Response } from '@core/api';
import { Observable } from 'rxjs/internal/Observable';
import { LeadDraftCommunication } from '@core/api/lead-draft-communication/lead-draft-communucation.model';

@Injectable({
  providedIn: 'root'
})
export class LeadDraftInfoCommunicationService {
  constructor(private http: HttpClient) { }

  search(request: FilterRequest): Observable<Response<LeadDraftCommunication>> {
    return this.http.post<Response<LeadDraftCommunication>>(environment.apiUrl + '/api/LeadDraftInfoCommunication/Search', request);
  }
}
